import React, { createContext, useContext, useState, useEffect } from 'react';

const DiagnosticsContext = createContext();

export function DiagnosticsProvider({ children }) {
  const [badDataBin, setBadDataBin] = useState(() => {
    // Load from localStorage on initialization
    try {
      const saved = localStorage.getItem('badDataBin');
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  // Save to localStorage whenever badDataBin changes
  useEffect(() => {
    try {
      localStorage.setItem('badDataBin', JSON.stringify(badDataBin));
    } catch (error) {
      console.warn('Failed to save bad data bin to localStorage:', error);
    }
  }, [badDataBin]);

  const addToBadDataBin = (point) => {
    setBadDataBin(prev => {
      if (prev.some(bad => bad.pointKey === point.pointKey)) return prev;
      const updated = [...prev, point];
      return updated;
    });
  };

  const clearBadDataBin = () => setBadDataBin([]);

  return (
    <DiagnosticsContext.Provider value={{ badDataBin, addToBadDataBin, clearBadDataBin }}>
      {children}
    </DiagnosticsContext.Provider>
  );
}

export function useDiagnostics() {
  return useContext(DiagnosticsContext);
}
